import {
  Component,
  ChangeDetectionStrategy,
  Input,
  InputSignal,
  input,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-boolean-column',
    templateUrl: './boolean-column.component.html',
    styleUrls: ['./boolean-column.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, TranslatePipe]
})
export class BooleanColumnComponent {
  value: InputSignal<boolean> = input<boolean>(false);
}
